// extracted by mini-css-extract-plugin
export default {"wrapper":"XTAKaE","container":"Q_ZZgM","content":"MJBEsK"};